import { TranscriptPreset } from '../types/analysis';

export class PresetService {
  private static readonly PRESET_CONFIGS: TranscriptPreset[] = [
    {
      id: 'demo-1',
      name: 'Demo 1 - Prezentacja produktu',
      description: 'Przykład rozmowy prezentacyjnej z klientem',
      filename: 'transcirpt-demo-1.json'
    },
    {
      id: 'demo-2',
      name: 'Demo 2 - Negocjacje',
      description: 'Przykład sesji negocjacyjnej',
      filename: 'transcript-demo-2.json'
    },
    {
      id: 'demo-3',
      name: 'Demo 3 - Zamknięcie sprzedaży',
      description: 'Przykład finalizacji transakcji',
      filename: 'transcirpt-demo-3.json'
    }
  ];

  /**
   * Get all available presets
   */
  static getAvailablePresets(): TranscriptPreset[] {
    return this.PRESET_CONFIGS;
  }

  /**
   * Get preset by ID
   */
  static getPresetById(id: string): TranscriptPreset | null {
    return this.PRESET_CONFIGS.find(preset => preset.id === id) || null;
  }

  /**
   * Load preset transcript content
   */
  static async loadPresetTranscript(presetId: string): Promise<string> {
    const preset = this.getPresetById(presetId);
    if (!preset) {
      throw new Error(`Preset with ID "${presetId}" not found`);
    }

    try {
      const response = await fetch(`/api/presets/${preset.filename}`);
      if (!response.ok) {
        throw new Error(`Failed to load preset: ${response.statusText}`);
      }

      const transcriptData = await response.json();

      // Convert structured transcript data to readable text format
      return this.convertToReadableText(transcriptData);
    } catch (error) {
      console.error('Error loading preset:', error);
      throw new Error('Nie udało się załadować predefiniowanego transkryptu');
    }
  }

  /**
   * Convert structured transcript JSON to readable text
   */
  private static convertToReadableText(transcriptData: any[]): string {
    if (!Array.isArray(transcriptData)) {
      throw new Error('Invalid transcript format');
    }

    return transcriptData
      .map(entry => {
        const speaker = entry.speaker_name || `Mówca ${entry.speaker_id}`;
        const sentence = entry.sentence || '';
        const timeStamp = entry.startTime ? ` [${entry.startTime}]` : '';

        return `${speaker}${timeStamp}: ${sentence}`;
      })
      .join('\n');
  }
}